import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import hero_bg from "../../assets/hero_bg.svg";
import search_icon from "../../assets/icons/search_icon.svg";

//Components
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import NftComp from "../../components/NftComp";

//placeholder
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import { shortenAddress } from "../../utils/shortenAddress";
import env from "../../constants/env";
import axios from "axios";
import colors from "../../constants/colors";
import { MOBILE } from "../../constants/breakpoints";
import { LoadingAnimation } from "../../components/ProcessingModal/Animation";
import { Row } from "../Assets/style";
import { LoaderWrapper } from "./style";
import Web3 from "web3";
import proxy_token_abi from "../../constants/abi";

function ProxyTokenList() {
  let wallet = useSelector((state: RootState) => state.walletState);
  const navigator = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [proxyTokensData, setProxyTokenData] = useState<any[]>([]);

  const [filteredProxyTokensData, setFilteredProxyTokensData] = useState<any[]>(
    []
  );

  const checkProxyTokensValidity = async () => {
    setIsLoading(true);
    const promiseArr = proxyTokensData.map(async (item) => {
      try {
        const response = await axios.get(
          `${env.PUBLIC_URL}/checkProxyTokenValidity/${item.token_id}`
        );
        console.log('response.data', response.data);

        return response.data;
      } catch (error) {
        console.error(error);
        return { isProxyTokenValid: false };
      }
    });
    const filteredProxyTokens = await Promise.all(promiseArr);
    setFilteredProxyTokensData(filteredProxyTokens);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!proxyTokensData?.length) return
    checkProxyTokensValidity();
  }, [proxyTokensData]);

  useEffect(() => {
    fetchUserProxyTokens();
  }, []);

  const fetchUserProxyTokens = async () => {
    try {
      setIsLoading(true);
      const queryUrl = `&token_addresses=${env.PROXY_TOKEN_CONTRACT_ADDRESS}`;
      const response = await axios.get(
        `${env.MORALIS_URL}/api/v2/${wallet.assetAddress}/nft?chain=${env.POLYGON_CHAIN}&format=decimal${queryUrl}`,
        {
          headers: {
            Accept: "application/json",
            "X-API-Key": env.MORALIS_API_KEY,
          },
        }
      );
      const web3 = new Web3(env.POLYGON_RPC_URL);
      const proxyContract = new web3.eth.Contract(
        proxy_token_abi,
        env.PROXY_TOKEN_CONTRACT_ADDRESS
      );
      const data = await Promise.all(response.data.result.map(async (item: any) => {
        if (!item.metadata) {
          const itemDataURL = await proxyContract.methods.tokenURI(item?.token_id).call();
          const itemMetaData = await axios.get(itemDataURL)
          return { ...item, parsedMetadata: itemMetaData?.data };
        }
        return { ...item, parsedMetadata: JSON.parse(item.metadata) };
      }));
      setProxyTokenData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNftClick = (data: any) => {
    const { token_id, token_address } = data
    localStorage.setItem('ACTIVE_PROXY_TOKEN_DETAILS', JSON.stringify(data))
    navigator(`/proxy-token-details/${env.POLYGON_CHAIN}/${wallet.assetAddress}/${token_address}/${token_id}`);
  };

  return (
    <>
      {/* {isLoading && (
        <ProcessingModal
          processingMessage="Loading proxy tokens from asset wallet..."
          loaderHeading="Loading..."
        />
      )} */}
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          min-height: 100vh;
          /* overflow: hidden; */
          background-color: #ffffff;
          background: url(${hero_bg});
          background-repeat: no-repeat;
          background-position: top right;
        `}
      >
        <Nav />
        <div
          css={css`
            display: flex;
            flex-direction: column;
            margin: 0 auto;
            margin-top: 158px;
            padding: 0 24px;
            gap: 90px;
            @media (min-width: ${MOBILE}px) {
              width: 1140px;
            }
          `}
        >

          <div
            css={css`
              display: flex;
              flex-direction: column;
            `}
          >
            <h1
              css={css`
                font-weight: 700;
                font-size: 56px;
                margin-bottom: 0;
                @media (max-width: ${MOBILE}px) {
                  font-size: 32px;
                }
              `}
            >
              Proxy Tokens in{" "}
            </h1>
            <h1
              css={css`
                font-weight: 700;
                font-size: 56px;
                color: #757272;
                margin: 0;
                @media (max-width: ${MOBILE}px) {
                  font-size: 32px;
                }
              `}
            >
              {shortenAddress(wallet.assetAddress ? wallet.assetAddress : "")}
            </h1>
            <p
              onClick={() => {
                navigator(`/assets/${wallet.assetChain}/${wallet.assetAddress}`);
              }}
              css={css`
                cursor: pointer;
                font-weight: 700;
                font-size: 24px;
                margin-top: 12px;
                margin-bottom: 0px;
                color: ${colors.INTERFACE_COLORS_BASALT};
                &:hover {
                  text-decoration: underline;
                }
              `}
            >
              View Assets List
            </p>
          </div>
          {/* <span
            css={css`
              display: flex;
              width: 462px;
              height: 48px;
              background: #ffffff;
              border: 1px solid #ccc4b3;
              border-radius: 12px;

              padding: 0 26px;
              align-items: center;
            `}
          >
            <img
              css={css`
                width: 22px;
                height: 22px;
              `}
              src={search_icon}
              alt=""
            />
            <input
              css={css`
                background: transparent;
                outline: none;
                border: none;
                width: 100%;
                height: 100%;
                padding: 0 12px;
                font-weight: 500;
                font-size: 16px;
              `}
              type="text"
              placeholder="Search"
            />
          </span> */}
          <div
            css={css`
              display: flex;
              flex-wrap: wrap;
              column-gap: 24px;
              row-gap: 32px;
              margin-bottom: 100px;
            `}
          >
            {isLoading
              ? <Row width="100%" justify="center">
                <LoaderWrapper>
                  <LoadingAnimation />
                </LoaderWrapper>
              </Row>
              : proxyTokensData.length > 0 ? (
                proxyTokensData.map((nft, index) => {
                  if (nft.parsedMetadata && nft.parsedMetadata !== null) {
                    return (
                      <NftComp
                        icon={nft.parsedMetadata.image}
                        label={nft.parsedMetadata.name}
                        key={nft.token_id}
                        onClick={() => handleNftClick(nft)}
                      />
                    );
                  }

                  return <></>;
                })
              ) : (
                <h1>No Proxy Tokens Found</h1>
              )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ProxyTokenList;
